module.exports = __webpack_public_path__ + "img/scallop-size-chart@2x-scaled.883f5957.jpg";